module.exports = __webpack_public_path__ + "static/media/footer_blue.412db1a9.png";